/**
 * Export React HTML
 * @param __html
 * @returns {{__html: *}}
 */
export default function return_html(__html) {
  return {__html}
}


// WEBPACK FOOTER //
// ./src/api/return_html.js